// src/components/CookieBanner/CookieBanner.jsx
import React, { useState, useEffect } from "react";

const GA_ID = "G-56CS28S76G";

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const clearConsent = () => localStorage.removeItem("cookieConsent");
    window.addEventListener("beforeunload", clearConsent);

    const consent = localStorage.getItem("cookieConsent");
    if (consent === null) {
      setIsVisible(true);
    } else if (consent === "accepted") {
      loadAnalytics();
    }

    return () => window.removeEventListener("beforeunload", clearConsent);
  }, []);

  const loadAnalytics = () => {
    if (!window.gtag) {
      const s1 = document.createElement("script");
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s1);

      const s2 = document.createElement("script");
      s2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', '${GA_ID}', { anonymize_ip: true });
      `;
      document.head.appendChild(s2);
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
    loadAnalytics();
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="
        fixed bottom-0 left-0 w-full
        bg-joyrideLight dark:bg-joyrideNavy
        text-black dark:text-joyrideLight
        p-4
        shadow-lg
        dark:shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.5)]
        z-50
      "
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between">
        <p className="text-sm mb-2 md:mb-0 text-center dark:text-shadow-sm">
          Tämä sivusto käyttää evästeitä parantaakseen käyttökokemusta ja keräämään
          tilastotietoa kävijöistä. Hyväksymällä analytiikkakäytännöt autat meitä
          kehittämään sivustoa. Lue lisää evästekäytännöstämme{" "}
          <a href="/privacy" className="underline hover:text-joyridePurple dark:hover:text-joyrideCyan">
            täällä
          </a>
          .
        </p>
        <div className="flex gap-2">
          <button
            onClick={declineCookies}
            className="px-4 py-2 rounded-lg border border-gray-400 hover:bg-gray-100 dark:hover:bg-joyridePurple transition"
          >
            Hylkää
          </button>
          <button
            onClick={acceptCookies}
            className="px-4 py-2 rounded-lg bg-joyridePurple text-white hover:bg-joyrideCyan transition"
          >
            Hyväksy
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
